import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import './InfoModal.css';
import './CheckoutFormShared/CheckoutFormShared.css';
import { pushEvent, ANALYTICS_EVENTS } from '../utils/analytics';

// Replaced Modal component with our own full-screen implementation
const InfoModal = ({ 
  show, 
  handleClose, 
  title, 
  body, 
  actionButton, 
  secondaryActionButton, // New prop
  closeButtonText,
  modalClassName = '', // New prop for custom modal class
  dialogClassName = '', // New prop for custom dialog class
  showCloseButton = true, // New prop to control X button visibility
}) => {
  // Track modal display with analytics
  useEffect(() => {
    if (show) {
      pushEvent({
        event: ANALYTICS_EVENTS.INFO_MODAL_VIEWED,
        title: title,
        source: window.location.pathname
      });
    }
  }, [show, title]);
  
  // REMOVED: Prevent background scrolling when modal is open 
  // This was preventing the modal content from scrolling properly
  // The CSS now handles proper modal scrolling without blocking body scroll
  
  // If not showing, return null
  if (!show) return null;

  return (
    <div className={`info-modal-fullscreen-container ${modalClassName}`}>
      <div className="info-modal-overlay" onClick={handleClose}></div>
      <div className={`info-modal-wrapper ${dialogClassName}`}>
        <div className="info-modal-content">
          {showCloseButton && (
            <button
              type="button"
              className="info-modal-x"
              aria-label="Close"
              onClick={handleClose}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
                <path d="M6 6L18 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
          )}
          <div className="info-modal-body-container">
            <div className="info-modal-title">{title}</div>
            <div className="info-modal-body">{body}</div>
            {actionButton && (
              <div className="info-modal-action-row">
                <Button
                  variant={actionButton.variant || 'primary'}
                  className={`checkout-button info-modal-action-btn ${actionButton.className || ''}`} // Use a generic class, allow passing custom class
                  onClick={actionButton.onClick} // Directly use the passed onClick
                  disabled={actionButton.disabled} // Use the passed disabled state
                >
                  {actionButton.text}
                </Button>
              </div>
            )}
            {/* Added close button text handling */}
            {closeButtonText && !actionButton && ( // Show close button if no action button or if explicitly provided
              <div className="info-modal-action-row">
                <Button variant="outline-secondary" onClick={handleClose} className="info-modal-close-btn">
                  {closeButtonText}
                </Button>
              </div>
            )}
             {/* Show cancel button if action button and closeButtonText are present */}
            {actionButton && closeButtonText && (
              <div className="info-modal-cancel-row mt-2">
                 <Button variant="link" onClick={handleClose} className="info-modal-cancel-link-btn">
                    {closeButtonText}
                 </Button>
              </div>
            )}
            {/* Render secondary action button if provided */}
            {secondaryActionButton && (
              <div className="info-modal-secondary-action-row mt-2">
                <Button
                  variant={secondaryActionButton.variant || 'link'}
                  onClick={secondaryActionButton.onClick}
                  disabled={secondaryActionButton.disabled}
                  className={`info-modal-secondary-action-btn ${secondaryActionButton.className || ''}`} // Use a generic class, allow passing custom class
                >
                  {secondaryActionButton.text}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
